//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import GetAppIcon from "@material-ui/icons/GetApp";
import {saveAs} from "file-saver";
import * as Utils from "eai-configurator-ui/components/Utils";

const DownloadButton = ({label, fileName, ...props}) => {
  const handleClick = () => {
    const options = {
      headers: {
        "Cache-Control": "public, max-age=80000, immutable",
      },
    };
    fetch(
      Utils.getBaseUrl() + "loader/downloadSample?name=" + fileName,
      options
    ).then(async (response) => {
      const filename = Utils.extractFileNameFromResponse(response);
      const blob = await response.blob();
      saveAs(blob, filename);
    });
  };
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        startIcon={<GetAppIcon/>}
        style={{padding: "4px 10px"}}
        {...props}
      >
        {label}
      </Button>
    </div>
  );
};
export default DownloadButton;
